import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Store from '@apply/store';
import { useAuthentication } from '../LoginPage';
import { FeatureType } from '@apply/constants';

export interface Actions {
    getUserNoticeCounts?: () => Promise<void>;
}

const NotificationPanel = ({ setLoading, setLoadError, actions, noticeCounts }) => {
    const { authentication, isFeatureEnabled } = useAuthentication();
    useEffect(() => {
        let canceled = false;

        if (authentication?.username) {
            actions
                .getUserNoticeCounts()
                .then(() => {
                    // istanbul ignore else
                    if (!canceled) {
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    // istanbul ignore else
                    if (!canceled) {
                        setLoadError(err);
                        setLoading(false);
                    }
                });
        }
        return () => {
            canceled = true;
        };
    }, [authentication?.username, actions, setLoading, setLoadError]);

    if (!isFeatureEnabled(FeatureType.Notices)) {
        return null;
    }

    return (
        <>
            <h2>My Notifications</h2>
            <section>
                <ul>
                    <li>
                        <Link to={'/notices'}>
                            {noticeCounts.total} Total Notices. ({noticeCounts.unread} unread)
                        </Link>
                    </li>
                </ul>
            </section>
        </>
    );
};

export const mapStateToProps = (state: Store.ApplyRootStateType) => ({
    noticeCounts: state.user?.noticeCounts ?? { total: 0, unread: 0 },
});

export const mapDispatchToProps = (dispatch: Store.ApplyDispatchType) => {
    const props: { actions: Actions; dispatch: Store.ApplyDispatchType } = {
        actions: {
            getUserNoticeCounts: () => dispatch(Store.CrossStore.getUserNoticeCounts()),
        },
        dispatch,
    };
    return props;
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationPanel);
